/* eslint-disable */
import React, { Component } from 'react';
import ActionButton from './ActionButton';

export default class RefreshButton extends Component {
    constructor(props) {
        super(props);
        this.refreshTable.bind(this);
    }

    refreshTable = () => {
        this.props.table.fireFetchData();
    };

    onActionClick = () => {
        this.props.reloadData();
    };

    render() {
        return (
            <ActionButton
                text={this.props.isMobile === true ? '' : 'Reload'}
                iconClass="icon-synchronize-6 with-text"
                onAction={() => this.onActionClick()}
            />
        );
    }
}
